import styled from 'styled-components';

export const Content = styled.div`
  padding: 0 15px;
`;

export default Content;
